import React, { useEffect, useState } from "react";
import { useFlutterwave, closePaymentModal } from "flutterwave-react-v3";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import PayWithWallet from './PayWithWallet';
import { logo_main } from "../../../assets";
import Api from "../../../api/axios";
import Title from "../../../utils/Title";
import AppWrapper from "../../../layout/AppWrapper";
import { useUserContext } from "../../../context/user_context";
import { usePackagesContext } from "../../../context/packages_context";
import BackButton from "../../BackButton";
import { Button } from "../../../styles";
import { naira } from "../../../utils/data";
import styled from "styled-components";




const MakePayment = (props) => {

    const [public_key] = useState(process.env.REACT_APP_FLUTTERWAVE_PUBLICKEY);

    const [load, setload] = useState(false);

    const [amount, setamount] = useState('');
    const [amountth, setamountth] = useState('');
    const [name, setname] = useState('');
    const [pid, setpid] = useState('');
    const [days, setdays] = useState('');

    const navigate = useNavigate();
    const location = useLocation();

    const { btoken, usertoken, businessData, userData } = useUserContext();

    const {
        openWalletPayment,
    } = usePackagesContext();


    // Check for Empty Fields 
    useEffect(() => {
        if (location?.state) {
            setamount(location?.state?.amount);
            setamountth(location?.state?.amount_th);
            setname(location?.state?.name);
            setpid(location?.state?.id);
            setdays(location?.state?.duration_days);
        } else {
            toast.warning('Choose a Package!');
            navigate('/user/settings/packages');
        }
    }, []);
    // Check for Empty Fields 

    const walletObj = { amount, amountth, pid, name, days };

    // Pay With Wallet

    const [paymentData, setpaymentData] = useState('');

    function walletPaymentOpen(e) {
        setpaymentData(e);
        openWalletPayment();
    }
    // Pay With Wallet

    // FLUTTERWAVE PAYMENT
    // FLUTTERWAVE PAYMENT
    const configflutter = {
        public_key: public_key,
        tx_ref: Date.now(),
        amount: Number(amount),
        currency: "NGN",
        payment_options: "card,mobilemoney,ussd",
        customer: {
            email: userData?.mail,
            phone_number: businessData?.phone,
            name: businessData?.name,
        },
        customizations: {
            title: "Package Payment",
            description: `Payment for ${ businessData?.name } `,
            logo: logo_main,
        },
    };

    const handleFlutterPayment = useFlutterwave(configflutter);

    let random = ''; // setting a token to prevent callback twice

    const FlutterHookBtn = () => {
        return (
            <Button
                pry
                className="btn mt-3 w-100"
                onClick={(e) => {
                    random = Date.now();
                    // makePayment('123456789');
                    handleFlutterPayment({
                        callback: (response) => {
                            if (response.status === 'successful') {
                                closePaymentModal();
                                makePayment(response.tx_ref);
                                // this will close the modal 
                            } else {
                                closePaymentModal(); // this will close the modal 
                                alert('unsuccessful');
                            }
                        },
                        onClose: () => { },
                    });
                }}
            >
                Flutterwave
            </Button>
        );
    };

    // FLUTTERWAVE PAYMENT
    // FLUTTERWAVE PAYMENT

    // On Success or Failure of Payment
    // On Success or Failure of Payment

    const makePayment = (e) => {
        if (random) {
            setload(true);
            const data = {
                usertoken,
                btoken,
                amount,
                packageid: pid,
                trxref: e,
                duration_days: days,
            };
            Api.post(`/subscribe.card.flutter`, data)
                .then((res) => {
                    if (res.success === true) {
                        random = '';
                        setload(false);
                        toast.success(res.message);
                        alert(res.message);
                        setTimeout(() => {
                            navigate('/user/settings/billing');
                        }, 1500);
                    } else {
                        setload(false);
                        toast.warning(res.message);
                    }
                })
                .catch((error) => {
                    setload(false);
                });
        } else {
            setload(false);
            toast.success('Multiple transaction detected, try again after 5 mins');
        }
    };
    // On Success or Failure of Payment
    // On Success or Failure of Payment


    return (
        <StyledPayment>

            <AppWrapper
                pagename={"settings"}
                route={"upgrade"}
            >

                {/* Title */}
                <Title title={"Packages"} />

                {/* Title */}

                <BackButton />
                <div className="mt-3 min-height-lg">
                    <div className="row">
                        <div className="col-md-12 mb-4">
                            <div className="card px-3 text-center py-3">
                                <h6>
                                    You are about to make payment for the package <span className="pry-text"> {name} </span>
                                </h6>
                            </div>
                        </div>

                        {load ?
                            <div className="mt-5 mx-auto text-center">
                                <ClipLoader color={"#023676"} loading={load} speedMultiplier="1.2" />
                                <div className="mt-4 ">
                                    <h5 className="fw-light">
                                        Please wait, your payment is processing{" "}
                                    </h5>
                                    <h6> Do not refresh page!!! </h6>
                                </div>
                            </div>
                            : (
                                <>
                                    <div className="col-md-6 mb-4 text-center">
                                        <div className="pay-bg">
                                            PAY WITH RENITRUST ACCOUNT

                                            <h6 className='mt-4'>Amount: <br />
                                                <span className="h3 pry-text fw-bold py-3"> {naira}{amountth}</span>
                                            </h6>

                                            <Button
                                                pry
                                                className='btn mt-3 w-100'
                                                onClick={(e) => walletPaymentOpen(walletObj)}>
                                                Pay with wallet
                                            </Button>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-4 text-center">
                                        <div className="pay-bg ">
                                            PAY WITH CARD

                                            <h6 className='mt-4'>Amount: <br />
                                                <span className="h3 pry-text fw-bold mt-3"> ₦{amountth}</span>
                                            </h6>

                                            <FlutterHookBtn />

                                        </div>
                                    </div>
                                </>
                            )}
                    </div>

                </div>

            </AppWrapper>

            <PayWithWallet
                paymentData={paymentData}
            />

        </StyledPayment>
    );
};

export default MakePayment;


const StyledPayment = styled.section`
    

    .pay-bg {
        background-color: var(--light-color);
        padding: 2rem 15px !important;
        border-radius: 10px;

    }
`;